import { createSelector } from 'reselect';
import { filter } from 'lodash/fp';
import { ApplicationState, AccountingCategory } from '@mews-commander/types';
import { createAction } from '@mews/framework';
import prefix from '../prefix';
import moduleSelector from '../selector';
import { createScopedEntitiesReducer, createScopedBaseEntitySelectors } from './utils';

export const NAME = 'accountingCategories';

const ACCOUNTING_CATEGORIES_LOADED = prefix('ACCOUNTING_CATEGORIES_LOADED');

export const setAccountingCategories = (entities: Array<AccountingCategory>, scope: string) =>
    createAction(ACCOUNTING_CATEGORIES_LOADED, { entities }, { scope });

export const [getAccountingCategories] = createScopedBaseEntitySelectors<
    ApplicationState,
    AccountingCategory,
    typeof NAME,
    'enterpriseId'
>(moduleSelector, NAME, 'enterpriseId');

export const getActiveAccountingCategories = createSelector(getAccountingCategories, filter('isActive'));

export const accountingCategoriesReducer = createScopedEntitiesReducer({
    FETCH_SUCCESS: ACCOUNTING_CATEGORIES_LOADED,
});
